import React from 'react'
import { IconEye, IconLock, IconUser } from '@tabler/icons-react'

import { SegmentedControl } from '@/components/buttons/SegmentedControl'

const OPTIONS = [
  {
    value: 'public',
    label: 'Public',
    Icon: IconEye,
    tooltip: 'Visible to everyone in your Balto Cloud organization',
  },
  {
    value: 'private',
    label: 'Private',
    Icon: IconLock,
    tooltip: 'Only visible to you',
  },
  {
    value: 'agent_visible',
    label: 'Agent',
    Icon: IconUser,
    tooltip: 'Visible to everyone in Balto Cloud and the agent on the call',
  },
]

/**
 * Visibility picker for /api/notes, built on the shared SegmentedControl.
 * Two-way (public / private) or three-way (public / private /
 * agent_visible) depending on the anchor — see `allowAgentVisible`.
 *
 * `allowAgentVisible=false` hides the Agent option entirely — used on
 * note anchors where it has no enforcement today (call, task, message;
 * only scorecard reads honor the agent_visible gate). Hidden, not
 * disabled — the option doesn't render at all. Pairs with NoteForm's
 * edit-mount coercion: an existing note already stored as
 * `agent_visible` gets coerced to public when the form mounts on a
 * non-allowing anchor, so the picker always reflects the value about
 * to be submitted.
 */
export const VisibilityRadio = ({
  value,
  onChange,
  disabled = false,
  allowAgentVisible = true,
}) => {
  const items = OPTIONS.filter(
    (option) => allowAgentVisible || option.value !== 'agent_visible'
  ).map((option) => ({
    accessor: option.value,
    active: value === option.value,
    onClick: () => onChange(option.value),
    disabled,
    dataTestId: `visibility-option-${option.value}`,
    icon: <option.Icon size={14} />,
    label: option.label,
    tooltip: option.tooltip,
  }))

  return <SegmentedControl items={items} aria-label="Note visibility" />
}
